
















































































































































































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import UserDetail from '../UserDetail.vue'
import { UserProfileDto } from '@/interfaces/userProfileDto';
import SearchFilter from '@/components/Utilities/SearchFilter.vue';
import ExternalUserInfo from '../ExternalUser/ExternalUserInfo.vue';
import { DropDownItem } from '@/services/DropDownItem';


interface UserIsCreated {
        succeeded: boolean,
        username: string
        message: string
}

@Component({
    components: {
        UserDetail,
        SearchFilter,
        ExternalUserInfo
    }
})
export default class UserManagement extends Vue {
    
    filterSelected: boolean = false;
    username: string = null;
    freeTextFilter : string = "";
    usernameFilter: string = "";
    nameFilter: string = "";
    surnameFilter: string = "";
    emailFilter: string = "";
    countryFilter: string = "";
    roleIdFilter: string = "";
    firstSearch: boolean = false;
    showLoading: boolean = false;
    placeholder: string ="Generic Search"
    users : Array<UserProfileDto> = new Array<UserProfileDto>();
    user: UserProfileDto =  null;
    userToAdd: string = "";
    addUserModalLoading: boolean = false;
    addUserExtraInfo: boolean = false;
    isSaveClicked: boolean = false;

    dropDownRoles: Array<any> = null;
    dropDownCountries: Array<any> = null;

    page: number = 1;
    resultsItems: any = {
        resultPage: new Array<UserProfileDto>(),
        total: 0
    };


    userInfoAD = {   
        email: '',
        id: '',
        userRoles: [],
        userName: '',
    }

    items = [] 
    emptyUser(){
        return {
            Name: '',
            Username: '',
            CountryName: '',
            RegionName: '',
            LocationName: '',
            Surname: '',
            Email: '',
            ContractType: 0,
            IdCountry: '',
            IsActive: null,
            IdUser: '',
            Roles: []
        };
    }
    async mounted() {
        this.dropDownRoles = await this.getDropdownRoles();
        this.dropDownCountries = await this.getDropdownCountries();
        this.user = this.emptyUser();
        
    }

    getTitleUsername(){
        return "User selected: " + this.username
    }

    searchFilterSearchEvent(genericSearch: string) {
        if(genericSearch != null)
            this.freeTextFilter = genericSearch;

        this.searchItems(true)
    }
    returnState(condition: boolean, clickButton: boolean): boolean {
        if (clickButton) 
            return condition;
        else 
            return null;
    }
    CheckIsNullOrEmpty(text: string) {
        if (text == null) return true;
        if (text == '') return true;
        return false;
    }

    checkFilters(){
        if (!this.CheckIsNullOrEmpty(this.nameFilter)) return true
        if (!this.CheckIsNullOrEmpty(this.usernameFilter)) return true
        if (!this.CheckIsNullOrEmpty(this.surnameFilter)) return true
        if (!this.CheckIsNullOrEmpty(this.emailFilter)) return true
        if (!this.CheckIsNullOrEmpty(this.countryFilter)) return true
        if (!this.CheckIsNullOrEmpty(this.roleIdFilter)) return true
        return false
    }

    searchFilterResertEvent(){
        this.nameFilter = "";
        this.emailFilter = "";
        this.surnameFilter = "";
        this.usernameFilter = "";
        this.countryFilter = "";
        this.freeTextFilter = "";
        this.roleIdFilter = "";
        this.filterSelected = false;
    }

    checkFilterParameter(){
        if (this.checkFilters())
        {
            this.filterSelected = true;
        }
        else 
        {
            this.filterSelected = false;
        }
    }

    resetSearch() {
        this.users = new Array<UserProfileDto>();
        this.resultsItems.resultPage = new Array<UserProfileDto>();
        this.page = 1;
    }
    impersonateCompleted(){
        
        this.$router.push('/');
        //General.RefreshPage();
    }
    async searchItems(start: boolean) {
        
        this.showLoading = true;
        if (start == true)
            this.resetSearch();
        try {
            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/userprofile/GetUsersWithFilter'),
                data: {
                    FreeText: this.freeTextFilter,
                    Username: this.usernameFilter,
                    Name: this.nameFilter,
                    Surname: this.surnameFilter,
                    Email: this.emailFilter,
                    CountryId: this.countryFilter,
                    RoleId: this.roleIdFilter,
                    CurrentPage: this.page
                },
                withCredentials: true,
                responseType: 'json'
            });                
            results.data.listPage.forEach(item => {
            {
                
                    
                this.resultsItems.resultPage.push({
                    Username: item.username,       
                    CountryName: item.countryName,
                    RegionName: item.regionName,
                    Name: item.name,
                    Surname: item.surname,  
                    Email: item.email,
                    ContractType: item.contractType,
                    LocationName: item.locationName,
                    IdCountry: item.idCountry,
                    IsActive: item.isActive,
                    IdUser: item.idUser
                });
            }

            });
            //console.log(this.resultsItems.resultPage)
            this.resultsItems.total = results.data.total;
            this.firstSearch = true;
            this.page += 1;

            this.showLoading = false;
        } catch (error) {

            General.HandleError(error, this);
        }
    }

    openModal(user: UserProfileDto) {
        this.username = user.Username;
        this.user = user;
        
        this.$bvModal.show('view-info-modal');
    }

    showAddUserModal(){
        this.addUserExtraInfo = false;
        this.userToAdd = ""
        this.$bvModal.show('add-user-modal')
    }

    hideAddUserModal(){
        this.$bvModal.hide('add-user-modal')
    }

    onCreateExternalUserSuccess(username: string) {
        this.hideAddUserModal();
        this.resetSearch();
        this.freeTextFilter = username;
        this.searchItems(false);
    }

    async addUser(force:boolean) {
 
        
        this.addUserModalLoading = true;

        if (this.userToAdd === "") {
            General.showAlertDanger("Empty string!", this);
            this.addUserModalLoading = false;
        } else {

            try{
                let response = null;
                if (!force){
                    this.user = this.emptyUser();
                    response = await axios.get(
                        General.GetApiUrl('/api/Admin/CreateUser'),
                        {
                            params: {
                                username: this.userToAdd
                            },
                            withCredentials: true,
                            responseType: 'json'
                        }
                    );
                }else{
                    this.isSaveClicked = true;
                    if(this.isValidForm()) {
                        this.user.Username = this.userToAdd;
                        this.user.IsActive = true;
                        response = await axios({
                            method: 'post',
                            url: General.GetApiUrl('/api/Admin/CreateUserNoHRSystem'),
                            data: this.user,
                            withCredentials: true,
                            responseType: 'json'
                        });                
                    }else{
                        this.addUserModalLoading = false;
                        return;
                    }
                    
                   
                }
                
                switch (response.data.statusDetail){
                    case 1:
                        General.showAlertSuccess(`${response.data.message} on (${response.data.username})`, this)
                        this.userToAdd = ""
                        this.addUserModalLoading = false;
                        this.addUserExtraInfo = false;
                    break;
                    case 3:
                        General.showAlertSuccess("No username found in Active Directory", this)
                        this.userToAdd = ""
                        this.addUserModalLoading = false;
                        this.addUserExtraInfo = false;
                    break;
                    case 2:
                        let app = this;
                        app.addUserModalLoading = false;
                        General.confirm("No HR System data. Do you want to add manually missing data?",app,()=>{
                            
                            app.addUserExtraInfo = true;
                        });
                        
                        
                }
           
            }catch(error){
                console.log(error)
                if (error.response) {
                    General.showAlertDanger(error.response.data.message, this)
                    this.userToAdd = error.response.data.username
                }
                else {
                    General.showAlertDanger("No response was received", this)
                }
                
                this.addUserModalLoading = false;
            }

           
        }
    }
    isValidForm() {
        
        if(this.CheckIsNullOrEmpty(this.user.Email)
            || this.CheckIsNullOrEmpty(this.user.Name)
            || this.CheckIsNullOrEmpty(this.user.Surname)
            || this.CheckIsNullOrEmpty(this.user.IdCountry)
            || this.user.ContractType==0
        ) {
            return false;
        }
        return true;
    }
    async getDropdownCountries(): Promise<Array<any>> {
        try {
            let country: DropDownItem = new DropDownItem();
            let countryList: DropDownItem[] = [];

            let response = await axios.get<any[]>(
                General.GetApiUrl('/api/Culture/GetCountriesAll'), {
                responseType: "json",
                withCredentials: true
            });

            if (response.data) {
                response.data.forEach(element => {
                    country = new DropDownItem();
                    country.idDropDownItem = element.idCountry;
                    country.itemText = element.name;

                    countryList.push(country);
                });
                return General.SetOptionsDropDown(countryList);
            }
        } catch (ex) {
            General.HandleError(ex, this);
            return null;
        }
    }

    async getDropdownRoles(): Promise<Array<any>> {
        try {
            let role: DropDownItem = new DropDownItem();
            let roleList: DropDownItem[] = [];

            let response = await axios.get<any[]>(
                General.GetApiUrl('/api/Admin/GetAllRoles'), {
                responseType: "json",
                withCredentials: true
            });

            if (response.data) {
                response.data.forEach(element => {
                    role = new DropDownItem();
                    role.idDropDownItem = element.id;
                    role.itemText = element.name;

                    roleList.push(role);
                });
                
                return General.SetOptionsDropDown(roleList);
            }
        } catch (ex) {
            General.HandleError(ex, this);
            return null;
        }
    }
    

}
